import { z } from 'zod'

const STORAGE_KEY = 'matevolno.inquiry.userProfile.v1'

export interface PersistedInquiryFields {
  name: string
  phone: string
}

// localStorage content is not trustworthy (older versions, manual edits), so
// each field is validated on its own and invalid ones are dropped.
const StoredInquiryFormSchema = z.object({
  name: z.string().optional().catch(undefined),
  phone: z.string().optional().catch(undefined),
})

export function loadStoredInquiryForm(): Partial<PersistedInquiryFields> {
  if (typeof window === 'undefined') return {}
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = StoredInquiryFormSchema.safeParse(JSON.parse(raw))
    if (!parsed.success) return {}
    const { name, phone } = parsed.data
    return {
      ...(name !== undefined && { name }),
      ...(phone !== undefined && { phone }),
    }
  } catch {
    return {}
  }
}

export function saveStoredInquiryForm(values: PersistedInquiryFields): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(values))
  } catch {
    // ignore (private mode / quota / disabled storage)
  }
}
